/**
 * Updates the URL with new parameters while maintaining the current URL parameters.
 * @param {string} newURL - The new destination URL.
 * @param {Object} newParams - The new URL parameters to be added. (Optional)
 */
function updateURL(newURL, newParams) {
  // Create a new URLSearchParams object with the current URL parameters
  const urlParams = new URLSearchParams(window.location.search);

  // Set new URL parameters
  if (newParams) {
    for (const [key, value] of Object.entries(newParams)) {
      urlParams.set(key, value);
    }
  }

  // Get the URL parameters as a string
  const paramsString = urlParams.toString();

  // Construct the updated URL
  const updatedURL = paramsString ? `${newURL}?${paramsString}` : newURL;

  // Return the updated URL
  return updatedURL;
}

export default updateURL;